export default "__VITE_ASSET__1149b6b3__"